export var componentsLocales = {
  forward: 'Дальше'
};